module.exports = __webpack_public_path__ + "static/media/6.3.9ee60413.png";